// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-1fae8fbc] .absolute.top-0.right-0.p-1.w-8.h-8.bg-white{z-index:20}.video-container[data-v-1fae8fbc]{overflow:hidden;position:relative;width:100%}.video-container[data-v-1fae8fbc]:after{padding-top:56.25%;display:block;content:\"\"}.video-container iframe[data-v-1fae8fbc]{position:absolute;top:0;left:0;width:100%;height:100%}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
